import { useMutation } from '@tanstack/react-query'
import Auth from '~models/auth'
import AuthRepository from '~repositories/impl/auth-repository'
import { setGuestToken } from '~utils/token'

const useGuestLogIn = () => {
  return useMutation<Auth.LogInGuest.Response, Error, Auth.LogInGuest>({
    mutationFn: AuthRepository.guestLogin,
    onSuccess: ({ access_token, anonymous_account_id }) => {
      setGuestToken(access_token, anonymous_account_id)
    },
  })
}

export default useGuestLogIn
